import { TimelineResolution } from "../TimelineResolution";

export class ContractResolutionCheckDto {
	public ContractId: string; // guid
	public Resolution: TimelineResolution;
	public CheckRequests: boolean;
	public CheckAllocations: boolean;
	public Start: Date;
	public End: Date;
}